import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { AdditionalDocResponse } from './additionaldocresponse';
import { AdditionalDocumentPayload } from './additionaldocumentpayload';
import { DocumentTypeResponse } from './documenttyperesponse';
import { DropboxSelection } from '../userdata/dropbox';
import { DEFAULT_ADDITIONAL_DOCUMENT_FORMATS } from '@/models/additionaldocuments/defaultAdditionalDocumentFormats';
declare var window: any;
@Module({ namespacedPath: 'documents/' })
export class DocumentStore extends VuexModule {
  private additionalDocumentList: AdditionalDocResponse[] = [];
  private documentTypeList: DocumentTypeResponse[] = [];
  private myDocumentList: AdditionalDocResponse[] = [];

  public get DocumentTypeList() {
    return this.documentTypeList;
  }

  public get AdditionalDocumentList() {
    return this.additionalDocumentList;
  }

  @mutation
  public setAdditionalDocumentList(payload) {
    this.additionalDocumentList = payload;
  }

  @mutation
  public setDocumentTypeList(payload) {
    this.documentTypeList = payload;
  }

  public get MyDocumentList() {
    return this.myDocumentList;
  }

  @mutation
  public setMyDocumentList(payload) {
    this.myDocumentList = payload;
  }

  @action({ mode: 'mutate' })
  public async getUserDocumentData() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v1/document',
      // 'https://run.mocky.io/v3/fefe8a26-6052-4127-b1e0-afff171bfaa4',
      // 'https://run.mocky.io/v3/c278c6fe-3664-4252-8707-804da6b8d1d6',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    if (resp.data.meta.success) {
      this.setAdditionalDocumentList(resp.data.data.documents);
    }
  }


  @action({ mode: 'mutate' })
  public async getMyDocumentData() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v2/credentialing/my-documents',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    console.log('/wl-profile-svc/api/v2/credentialing/my-documents', resp);
    if (200 === resp.status || resp.data.meta.success) {
      this.setMyDocumentList(resp.data.data);
    }
  }

  @action({ mode: 'mutate' })
  public async getDocumentTypeList(companyCode) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v1/document/documentTypes/' + companyCode,
      // 'https://run.mocky.io/v3/1f2ae280-128f-4515-946d-01204feece52',
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    if (resp.data.meta.success) {
      this.setDocumentTypeList(resp.data.data.documentTypes);
    }
  }

  @action({ mode: 'mutate' })
  public async deleteAdditionalDocument(documentId: number) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/document/' + documentId,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async uploadAdditionalDocument(payload: AdditionalDocumentPayload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const formData = new FormData();
    formData.append('document', payload.documentFile);
    formData.append('effectiveDTTM', payload.effectiveDate);
    formData.append('documentType', payload.documentType);
    formData.append('expiryDTTM', payload.expiryDate);
    formData.append('documentId', payload.documentId.toString());
    formData.append('licenseState', payload.licenseState);
    formData.append('licenseNumber', payload.licenseNumber);
    formData.append('doesNotExpire', payload.doesNotExpire.toString());
    formData.append('name', payload.documentName);
    const resp = await axios.post('/wl-profile-svc/api/v1/document', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: bearerToken,
      },
    });
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async uploadAdditionalDocumentV2(payload: AdditionalDocumentPayload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const formData = new FormData();
    formData.append('document', payload.documentFile);
    formData.append('effectiveDTTM', payload.effectiveDate);
    formData.append('documentType', payload.documentType);
    formData.append('expiryDTTM', payload.expiryDate);
    formData.append('documentId', payload.documentId.toString());
    formData.append('licenseState', payload.licenseState);
    formData.append('licenseNumber', payload.licenseNumber);
    formData.append('doesNotExpire', payload.doesNotExpire.toString());
    formData.append('name', payload.documentName);
    const resp = await axios.post('/wl-profile-svc/api/v2/document', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: bearerToken,
      },
    });
    return resp.data;
  }

  @mutation
  public removeAdditonalDocument(element: AdditionalDocResponse) {
    this.additionalDocumentList.forEach((value, index) => {
      if (value == element) this.additionalDocumentList.splice(index, 1);
    });
  }

  @action({ mode: 'mutate' })
  public async uploadDropboxFile(
    payload: AdditionalDocumentPayload,
  ): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.selectFromDropbox([])
        .then((selected) => {
          const file = selected.file;
          if (!!file) {
            resolve(file.link);
          } else {
            resolve(selected.status);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @action({ mode: 'mutate' })
  public selectFromDropbox(extensions: string[]): Promise<DropboxSelection> {
    const options: Dropbox.ChooserOptions = {
      // tslint:disable-next-line:no-empty
      success: (files) => {},

      linkType: 'direct',

      multiselect: false,
      extensions: (
        vxm.configs.getGlobalConfigValue('ADDITIONAL_DOCUMENT_FORMATS') ||
        DEFAULT_ADDITIONAL_DOCUMENT_FORMATS
      ).split(','),

      folderselect: false,
      sizeLimit: 2097152, // 2MB
    };
    try {
      return new Promise<DropboxSelection>((resolve, reject) => {
        const success = (files: ReadonlyArray<Dropbox.ChooserFile>): void => {
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < files.length; i++) {
            resolve(DropboxSelection.success(files[i]));
            return;
          }
          reject('Error selecting Dropbox file.');
        };
        const cancel = (): void => {
          resolve(DropboxSelection.cancel());
        };
        options.cancel = cancel;
        options.success = success;
        window.Dropbox.choose(options);
      });
    } catch (ex) {
      return Promise.reject(ex);
    }
  }

  @action({ mode: 'mutate' })
  public async uploadViaDropbox(documentPayload) {
    const dbxUploadUrl = '/wl-profile-svc/api/v1/document/dropbox';
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    console.log('bearerToken drop box attribute:' + bearerToken);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    };

    const dbxRec = {
      fileLink: documentPayload.documentFile,
      documentId: documentPayload.documentId,
      effectiveDTTM: documentPayload.effectiveDate,
      expiryDTTM: documentPayload.expiryDate,
      licenseState: documentPayload.licenseState,
      licenseNumber: documentPayload.licenseNumber,
      doesNotExpire: documentPayload.doesNotExpire.toString(),
      name: documentPayload.documentName,
      documentType: documentPayload.documentType,
    };
    console.log('dbxRec >> ' + dbxRec);
    const resp = await axios.post(dbxUploadUrl, dbxRec, config);
    return resp.data;
  }
}
